import {
  FolderItem,
  Intake,
  medicineHoraires,
  ordonnanceDurations,
  OrdonnanceMedicine,
  Patient,
  Task,
} from "@/src/data/allTypes";
import { getUserId } from "@/src/utils/utils";
import moment from "moment";

export function generateTasks({
  patient,
  parent,
  ordonnanceMedicine,
}: {
  patient: Patient;
  parent: FolderItem;
  ordonnanceMedicine: OrdonnanceMedicine;
}): Task[] {
  let tasks: Task[] = [];
  if (!ordonnanceMedicine.duration) return [];
  let duration = ordonnanceDurations[ordonnanceMedicine?.duration];
  if (!duration) return [];

  for (let day = 0; day < duration.days; day++) {
    let date = moment(ordonnanceMedicine.startDate)
      .add(day, "days")
      .format("YYYY-MM-DD " + moment().format("HH:00:00"));

    for (let intake of ordonnanceMedicine.intakes || []) {
      if (!intake?.horaire) continue;

      let start = getTaskStart({ intake, date });
      let end = getTaskEnd({ intake, start });
      let task: Task = {
        patient,
        parent,
        creator: getUserId(),
        doctor: getUserId(),
        medicine: ordonnanceMedicine.medicine,
        notes: ordonnanceMedicine.notes,
        start,
        end,
        posology: intake.posology,
        dilutionVolume: intake.dilutionVolume,
        dilutionSolution: intake.solution,
        duration: intake.duration,
        route: intake.route,
        unit: intake.unit,
      };
      tasks?.push(task);
    }
  }
  return tasks;
}

function getTaskStart({ intake, date }: { intake: Intake; date: string }) {
  let medicineHoraire = medicineHoraires[intake.horaire];
  console.log("intake", intake);
  let start =
    medicineHoraire?.getTime?.(moment(date)) ||
    moment(`${date} ${medicineHoraire?.name}`).format("YYYY-MM-DD HH:mm:00");
  if (start == "Invalid date")
    throw new Error(
      "Date de début invalide pour certaines tâches Horaire : " + intake.horaire
    );

  return start;
}

function getTaskEnd({ intake, start }: { intake: Intake; start: string }) {
  let end = moment(start).add(1, "hour").format("YYYY-MM-DD HH:mm:00");
  if (intake.duration)
    end = moment(start)
      .add(intake.duration, "minutes")
      .format("YYYY-MM-DD HH:mm:00");

  if (end == "Invalid date")
    throw new Error(
      "Date de fin invalide pour certaines tâches Horaire : " + intake.horaire
    );
  return end;
}
